import _ from 'lodash'
import { FormGroup } from '@agro-club/agroclub-shared'
import env from 'env'
import { CurrencySign, Hedges } from 'modules/domain/export/types'
import { FormikFieldsType } from 'modules/domain/types'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { DatePicker } from 'views/components/DatePicker/DatePicker'
import { FormInput } from 'views/components/form/FormInput'
import { FormCurrencySelect } from 'views/components/FormCurrencySelect/FormCurrencySelect'
import { SharedModalInputs } from 'views/components/SharedModal'

export type NaturalFields = Nullable<Pick<Hedges, 'currency' | 'option_volume' | 'settlement_date' | 'strike'>>

const currency = env.REACT_APP_CURRENCY_SYMBOL

type Props = {
  formik: FormikFieldsType
}

export const CommonNaturalFields: FC<Props> = ({ formik }) => {
  const { t } = useTranslation('export')

  const formCurrencyId = formik.values.currency

  return (
    <SharedModalInputs>
      <FormCurrencySelect label={t('currency')} formik={formik} field="currency" />
      <FormGroup label={t('convertDate')} error={formik.errors.settlement_date}>
        <DatePicker
          value={formik.values.settlement_date}
          onChange={(data) => formik.setFieldValue('settlement_date', data['date'])}
          error={!!formik.errors.settlement_date}
          placeholder={t('common:datePlaceholder')}
        />
      </FormGroup>
      <FormInput
        formik={formik}
        field="option_volume"
        label={`${t('forwardSum')}, ${CurrencySign[formCurrencyId]}`}
        type="number"
      />
      <FormInput
        formik={formik}
        field="strike"
        label={`${t('rate')}, ${t('currencyPerCurrency', { currency, perCurrency: CurrencySign[formCurrencyId] })} `}
        type="number"
      />
    </SharedModalInputs>
  )
}
